import { Stack, TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment-timezone";
import { useEffect } from "react";
import { DateTimePickerComponentProps } from "./types";

export const DateTimePickerComponent = (props: DateTimePickerComponentProps) => {
  useEffect(() => {
    moment.tz.setDefault("Etc/UTC");
  });

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Stack>
        <DatePicker
          inputFormat="MM/DD/YYYY"
          mask="__/__/____"
          label={props.label}
          value={props.dateValue}
          onChange={props.handleChange}
          renderInput={(params) => (
            <TextField {...params} required={props.required} {...props.textFieldProps} />
          )}
        />
      </Stack>
    </LocalizationProvider>
  );
};
